import { render, staticRenderFns } from "./TitleAndDescriptionPreview.vue?vue&type=template&id=2d847ed4&scoped=true&"
import script from "./TitleAndDescriptionPreview.vue?vue&type=script&lang=js&"
export * from "./TitleAndDescriptionPreview.vue?vue&type=script&lang=js&"
import style0 from "./TitleAndDescriptionPreview.vue?vue&type=style&index=0&id=2d847ed4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d847ed4",
  null
  
)

export default component.exports